import { render, staticRenderFns } from "./CategoryCourses.vue?vue&type=template&id=5483b261&scoped=true"
import script from "./CategoryCourses.vue?vue&type=script&lang=js"
export * from "./CategoryCourses.vue?vue&type=script&lang=js"
import style0 from "./CategoryCourses.vue?vue&type=style&index=0&id=5483b261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483b261",
  null
  
)

export default component.exports